export default __webpack_public_path__ + "12b31aaf4ba3de47178ebbf686e00385.png";